<template>
  <v-layout>
    <v-main :class="containerState">
      <v-container min-width="100%">
        <AppBar
          :rule="rule"
          :realm="realm"
          :apiUrl="ruleEditorConfig.api"
          @snackbarEvent="snackbarEvent"
        />
        <WizardStepper :step="step" />
        <WizardSlider v-if="items" :items="items" :page="page" />
        <!--Snackbar-->
        <v-snackbar v-model="snackbar" top color="green" timeout="5000">
          {{ snackbarText }}
          <template v-slot:actions="{ attrs }">
            <v-btn
              color="white"
              variant="text"
              v-bind="attrs"
              @click="snackbar = false"
              >OK</v-btn
            >
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import version from "../version";
import AppBar from "./components/AppBar.vue";
import WizardStepper from "./components/WizardStepper.vue";
import WizardSlider from "./components/WizardSlider.vue";
export default {
  name: "RuleWizardControlPanel",
  components: { AppBar, WizardStepper, WizardSlider },
  mixins: [utils, events],
  props: ["rmConfig", "ruleEditorConfig", "realm"],
  data: function () {
    return {
      appVersion: version,
      snackbar: false,
      snackbarText: "",
      overlay: false,
      containerState: "expanded",
      search: "",
      rule: JSON.parse(sessionStorage.getItem("rule")),
      page: location.pathname.split("/").pop(),
    };
  },
  created() {
    //Prevents a random navigation without necessary data
    if (!this.rule) {
      this.$router.push("/"); //redirect to home
    }
  },
  mounted() {
    console.log("Mounted demf-rule-editor-control-panel v", this.appVersion);

    document.addEventListener(
      "language-localstorage-changed",
      this.languageLocalstorageChanged,
    );

    this.containerState =
      localStorage.getItem("sidenav") === "opened" ? "reduced" : "expanded";

    document.addEventListener("sidenav-localstorage-changed", (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    });
    //Path change listening
    this.$router.beforeEach((to, from, next) => {
      if (to.path.includes("assets")) {
        this.page = "assets";
      } else if (to.path.includes("conditions")) {
        this.page = "conditions";
      } else if (to.path.includes("actions")) {
        this.page = "actions";
      } else if (to.path.includes("summary")) {
        this.page = "summary";
      } else {
        this.page = to.path.split("/").pop();
      }
      next();
    });
  },
  beforeUnmount() {
    document.removeEventListener(
      "language-localstorage-changed",
      this.languageLocalstorageChanged,
    );
  },
  watch: {
    page(val) {
      return val;
    },
  },

  computed: {
    //Sets step on Stepper for the visited page
    step() {
      let step = { assets: "0", conditions: "1", actions: "2", summary: "3" };
      return this.page ? step[this.page] : 3;
    },
    //Retrieves from configurations the list of Assets or Actions...
    items() {
      return this.rmConfig[this.page] || null;
    },
  },
  methods: {
    languageLocalstorageChanged(event) {
      this.setLocale(event.detail.storage);
    },
    snackbarEvent(value, text) {
      this.snackbar = value;
      this.snackbarText = text;
    },
  },
};
</script>
<style scoped>
main.expanded {
  margin-left: 56px;
}
main.expanded header#upp-bar {
  margin-left: 56px;
  width: calc(100% - 56px) !important;
}
main.reduced {
  margin-left: 256px;
}
main.reduced header#upp-bar {
  margin-left: 256px;
  width: calc(100% - 256px) !important;
}

.activePosition {
  position: relative;
  z-index: 5;
}
</style>
